import { useQuery, useQueryClient } from '@tanstack/react-query';
import apiService from '../../services/api';
import { queryKeys } from '../../api/queryKeys';

const PURCHASES_STALE_MS = 2 * 60 * 1000;

export function fetchUserPurchases() {
  return apiService.request('/api/shop/user/purchases/');
}

/** Authenticated user's purchases (owned badges, download UI). */
export function useUserPurchasesQuery(enabled, options = {}) {
  return useQuery({
    queryKey: queryKeys.shop.userPurchases,
    queryFn: fetchUserPurchases,
    enabled: Boolean(enabled),
    staleTime: PURCHASES_STALE_MS,
    ...options,
  });
}

/** Build owned track/album maps from API list (same shape as AppContext SET_OWNED). */
export function ownedMapsFromPurchases(purchases) {
  const trackUuids = {};
  const albumIds = {};
  (purchases || []).forEach((p) => {
    if (p?.item_type === 'track' && p?.uuid) {
      trackUuids[String(p.uuid)] = true;
    }
    if (p?.item_type === 'album') {
      if (p?.album_id != null) albumIds[String(p.album_id)] = true;
      if (p?.album_uuid != null) albumIds[String(p.album_uuid)] = true;
      if (p?.uuid !== undefined && p?.uuid !== null) albumIds[String(p.uuid)] = true;
    }
  });
  return { trackUuids, albumIds };
}

export function useInvalidateUserPurchases() {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: queryKeys.shop.userPurchases });
}
